import axios from '@config/axios-config';
import { IApiResponse } from '@datatype/common/api-type';
import { ISubscriptionData, EApiSubscriptionStatus } from '@datatype/billing/api-type';

// 나의 구독 조회 api
export const getMySubscriptionApi = async (): Promise<IApiResponse<ISubscriptionData | null>> => {
  const response = await axios
    .get<IApiResponse<ISubscriptionData | null>>('/api/v1/billing/me/subscription')
    .then((res) => res.data);
  return response;
};

// 나의 구독 상태 동기화 api
// - 클라이언트(RN 앱)가 RevenueCat에서 본 활성 여부(status)를 백엔드에 전달
// - 백엔드는 클라/DB 상태 비교 후 부정합한 경우에만 RevenueCat 재조회로 보정
// - 응답으로 동기화 후의 구독 상태(없으면 null)를 반환
export const syncMySubscriptionApi = async (
  status: EApiSubscriptionStatus,
): Promise<IApiResponse<ISubscriptionData | null>> => {
  const body = { status };
  const response = await axios
    .post<IApiResponse<ISubscriptionData | null>>('/api/v1/billing/me/subscription/sync', body)
    .then((res) => res.data);
  return response;
};
